import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {combineLatest, Observable} from 'rxjs';
import {ApplicationPackage} from 'src/app/enums/application-package.enum';
import {Service} from 'src/app/enums/service.enum';
import {CustomHttpUrlEncodingCodec} from 'src/app/main/encoder';
import {TrailerProcessHistory} from 'src/app/model/cms-vod-core/content-controller/trailer-process-history.model';
import {TrailerOperationProcessesCompletedCount} from 'src/app/model/cms-vod-core/total-finished-task-count-by-user-response.model';
import {ComingSoonContent} from 'src/app/model/coming-soon-content.model';
import {ContentMediaFile} from 'src/app/model/content-media-file.model';
import {PageOfComingSoonContent} from 'src/app/model/page-of-coming-soon-content.model';
import {FileTransferLog} from 'src/app/model/process-data-models/file-transfer-log.model';
import {TranscodingSecondLog} from 'src/app/model/process-data-models/transcoding-second-log.model';
import {VideoOperationProcess} from 'src/app/model/vod-operations/video-operation-process-model';
import {VodQueryParams} from 'src/app/model/vod-query-params.model';
import {environment} from 'src/environments/environment';
import {ProcessRequest} from '../../../model/vod-operations/video-operation-process-request.model';

@Injectable({
  providedIn: 'root',
})
export class ComingSoonContentsService {
  readonly comingSoonContentApi = environment.endPoint + ApplicationPackage.CMS_VOD + Service.COMING_SOON;

  constructor(private http: HttpClient) {}

  getAllComingSoonContents(comingSoonQueryParams?: VodQueryParams): Observable<PageOfComingSoonContent> {
    let queryParams = new HttpParams({
      encoder: new CustomHttpUrlEncodingCodec(),
    });

    if (comingSoonQueryParams.page > 0) {
      queryParams = queryParams.set('page', <any>comingSoonQueryParams.page);
    }
    if (comingSoonQueryParams.itemCount) {
      queryParams = queryParams.set('itemCount', <any>comingSoonQueryParams.itemCount);
    }
    if (comingSoonQueryParams.contentName) {
      queryParams = queryParams.set('name', <any>comingSoonQueryParams.contentName);
    }
    if (comingSoonQueryParams.guid) {
      queryParams = queryParams.set('guid', <any>comingSoonQueryParams.guid);
    }
    if (comingSoonQueryParams.status) {
      queryParams = queryParams.set('status', <any>comingSoonQueryParams.status);
    }
    if (comingSoonQueryParams.trailerOperationProcessNames) {
      queryParams = queryParams.set('trailerOperationProcessName', <any>comingSoonQueryParams.trailerOperationProcessNames);
    }
    if (comingSoonQueryParams.trailerAssignee) {
      queryParams = queryParams.set('trailerAssignee', <any>comingSoonQueryParams.trailerAssignee);
    }
    if (comingSoonQueryParams.planStartTime) {
      queryParams = queryParams.set('planStartTime', <any>comingSoonQueryParams.planStartTime);
    }
    if (comingSoonQueryParams.planEndTime) {
      queryParams = queryParams.set('planEndTime', <any>comingSoonQueryParams.planEndTime);
    }
    if (comingSoonQueryParams.trailerCompletionTime) {
      queryParams = queryParams.set('comingSoonCompletionTime', <any>comingSoonQueryParams.trailerCompletionTime);
    }
    if (comingSoonQueryParams.sortParam) {
      queryParams = queryParams.set('sortParam', <any>comingSoonQueryParams.sortParam);
    }

    return this.http.get<PageOfComingSoonContent>(this.comingSoonContentApi, {params: queryParams});
  }
  report(comingSoonQueryParams?: VodQueryParams): Observable<string> {
    let queryParams = new HttpParams({
      encoder: new CustomHttpUrlEncodingCodec(),
    });

    if (comingSoonQueryParams.contentName) {
      queryParams = queryParams.set('name', <any>comingSoonQueryParams.contentName);
    }
    if (comingSoonQueryParams.guid) {
      queryParams = queryParams.set('guid', <any>comingSoonQueryParams.guid);
    }
    if (comingSoonQueryParams.status) {
      queryParams = queryParams.set('status', <any>comingSoonQueryParams.status);
    }
    if (comingSoonQueryParams.trailerOperationProcessNames) {
      queryParams = queryParams.set('trailerOperationProcessName', <any>comingSoonQueryParams.trailerOperationProcessNames);
    }
    if (comingSoonQueryParams.trailerAssignee) {
      queryParams = queryParams.set('trailerAssignee', <any>comingSoonQueryParams.trailerAssignee);
    }
    if (comingSoonQueryParams.planStartTime) {
      queryParams = queryParams.set('planStartTime', <any>comingSoonQueryParams.planStartTime);
    }
    if (comingSoonQueryParams.planEndTime) {
      queryParams = queryParams.set('planEndTime', <any>comingSoonQueryParams.planEndTime);
    }
    if (comingSoonQueryParams.trailerCompletionTime) {
      queryParams = queryParams.set('comingSoonCompletionTime', <any>comingSoonQueryParams.trailerCompletionTime);
    }

    return this.http.get<string>(this.comingSoonContentApi + '/report', {params: queryParams});
  }
  getComingSoonContentById(id: number): Observable<ComingSoonContent> {
    return this.http.get<ComingSoonContent>(this.comingSoonContentApi + `/${id}`);
  }

  createComingSoonContent(content: ComingSoonContent): Observable<ComingSoonContent> {
    return this.http.post<ComingSoonContent>(this.comingSoonContentApi, content);
  }

  reProcessFailedOperation(comingSoonContentId: number, trailerOperationName: string): Observable<any> {
    return this.http.post<any>(
      this.comingSoonContentApi + `/${comingSoonContentId}/traileroperationprocesses/${trailerOperationName}/reprocess`,
      null,
      {
        responseType: 'text' as 'json',
      },
    );
  }
  updateComingSoonContent(content: ComingSoonContent): Observable<ComingSoonContent> {
    return this.http.put<ComingSoonContent>(this.comingSoonContentApi, content);
  }

  updateComingSoonContentPromise(content: ComingSoonContent) {
    return this.http.put(this.comingSoonContentApi, content).toPromise();
  }

  deleteComingSoonContent(id: number): Observable<any> {
    return this.http.delete<any>(this.comingSoonContentApi + `/${id}`);
  }

  //Get Trailers
  listTrailerWatchFolder(): Observable<ContentMediaFile[]> {
    return this.http.get<ContentMediaFile[]>(this.comingSoonContentApi + `/trailers/listwatchfolder`);
  }

  //Get Content Media Files
  getContentMediaFilesByMediaType(contentId: number, mediaTypes?: string[]): Observable<ContentMediaFile[]> {
    let queryParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    if (mediaTypes) {
      queryParams = queryParams.set('mediaType', <any>mediaTypes);
    }
    return this.http.get<ContentMediaFile[]>(this.comingSoonContentApi + `/${contentId}/mediafiles`, {params: queryParams});
  }

  //Get Trailer Operation Processes
  getContentTrailerOperationProcesses(contentId: number): Observable<VideoOperationProcess[]> {
    return this.http.get<VideoOperationProcess[]>(this.comingSoonContentApi + `/${contentId}/traileroperationprocesses`);
  }

  getComingSoonContentTrailerProcessHistory(comingsoonId: number): Observable<TrailerProcessHistory[]> {
    return this.http.get<TrailerProcessHistory[]>(this.comingSoonContentApi + `/${comingsoonId}//traileroperationprocesses/history`);
  }

  //Add Trailer
  moveTrailerFile(contentId: number, fileName: string, videoFormat: string): Observable<any> {
    let queryParam = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    if (videoFormat) {
      queryParam = queryParam.set('videoFormat', <any>videoFormat);
    }

    return this.http.post<any>(this.comingSoonContentApi + `/${contentId}/trailers/${fileName}/add`, null, {
      responseType: 'text' as 'json',
      params: queryParam,
    });
  }

  //Remove trailer
  removeTrailerFile(contentId: number): Observable<any> {
    return this.http.get<any>(this.comingSoonContentApi + `/${contentId}/trailers/remove`, {responseType: 'text' as 'json'});
  }

  //Upload poster
  setPosterToContent(contentId: number, posterDefinitionId: number, autoPosterCreate: boolean, file: File): Observable<any> {
    let queryParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    if (autoPosterCreate) {
      queryParams = queryParams.set('autoPosterCreate', <any>autoPosterCreate);
    }
    const formData: FormData = new FormData();
    formData.append('file', file);

    return this.http.post<any>(this.comingSoonContentApi + `/${contentId}/posters/${posterDefinitionId}/upload`, formData, {
      params: queryParams,
      responseType: 'text' as 'json',
    });
  }

  //Remove Poster
  removePoster(contentId: number, posterDefinitionId: number): Observable<string> {
    return this.http.delete<string>(this.comingSoonContentApi + `/${contentId}/posters/${posterDefinitionId}`, {responseType: 'text' as 'json'});
  }

  //Get Transfer Logs
  getFileTransferLog(contentId?: number, mediaTypes?: string[]): Observable<FileTransferLog[]> {
    let queryParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    if (mediaTypes) {
      queryParams = queryParams.set('mediaTypes', <any>mediaTypes);
    }
    return this.http.get<FileTransferLog[]>(this.comingSoonContentApi + `/${contentId}/filetransferlogs`, {params: queryParams});
  }

  //Get Transcoding2logs
  getTranscodingSecondLog(contentId: number, mediaType: string): Observable<TranscodingSecondLog[]> {
    let queryParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    if (mediaType) {
      queryParams = queryParams.set('mediaType', <any>mediaType);
    }
    return this.http.get<TranscodingSecondLog[]>(this.comingSoonContentApi + `/${contentId}/transcode2ndlogs`, {params: queryParams});
  }

  trailerOperationProcesses(contentId: number, operation: string, action: string, processRequest: ProcessRequest): Observable<string> {
    return this.http.post<string>(this.comingSoonContentApi + `/${contentId}/traileroperationprocesses/${operation}/${action}`, processRequest, {
      responseType: 'text' as 'json',
    });
  }
  trailerOperationBulkDirect(contentIds: number[], trailerOperationName: string, processRequest: ProcessRequest): Observable<string> {
    let queryParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    if (contentIds) {
      queryParams = queryParams.set('contentId', <any>contentIds);
    }
    return this.http.post<string>(this.comingSoonContentApi + `/bulk/traileroperationprocesses/${trailerOperationName}/direct`, processRequest, {
      params: queryParams,
      responseType: 'text' as 'json',
    });
  }
  trailerOperationBulkProcess(
    contentIds: number[],
    trailerOperationName: string,
    action: string,
    processRequest: ProcessRequest,
  ): Observable<string> {
    let queryParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    if (contentIds) {
      queryParams = queryParams.set('contentId', <any>contentIds);
    }

    return this.http.post<string>(this.comingSoonContentApi + `/bulk/traileroperationprocesses/${trailerOperationName}/${action}`, processRequest, {
      params: queryParams,
      responseType: 'text' as 'json',
    });
  }

  trailerOperationDirect(comingsoonContentId: number, operationName: string, processRequest: ProcessRequest): Observable<string> {
    return this.http.post<string>(
      this.comingSoonContentApi + `/${comingsoonContentId}/traileroperationprocesses/${operationName}/direct`,
      processRequest,
      {responseType: 'text' as 'json'},
    );
  }

  publish(id: number): Observable<string> {
    return this.http.get<string>(this.comingSoonContentApi + `/${id}/publish`, {responseType: 'text' as 'json'});
  }

  trailerOperaitonProcessHistory(
    comingSoonContentId: number,
    comingsoonOperationProcess: string,
    status: string[],
  ): Observable<TrailerProcessHistory[]> {
    let queryParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    if (comingsoonOperationProcess) {
      queryParams = queryParams.set('trailerOperationProcess', <any>comingsoonOperationProcess);
    }
    if (status) {
      queryParams = queryParams.set('status', <any>['Pending', 'Started', 'Finished']);
    }
    return this.http.get<TrailerProcessHistory[]>(this.comingSoonContentApi + `/${comingSoonContentId}/traileroperationprocesses/history`, {
      params: queryParams,
    });
  }

  setPlanProfile(comingSoonContent: ComingSoonContent): Observable<ComingSoonContent> {
    return this.http.put<ComingSoonContent>(this.comingSoonContentApi + '/plan', comingSoonContent);
  }

  getCompletedComingSoonContentsByTime(completionTime: number): Observable<TrailerOperationProcessesCompletedCount[]> {
    let queryParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    queryParams = queryParams.set('completionTime', <any>completionTime);

    return this.http.get<TrailerOperationProcessesCompletedCount[]>(this.comingSoonContentApi + '/completedcomingsooncontentsbytime', {
      params: queryParams,
    });
  }
}
